export default {
  methods: {
    // extracts the specified color value from the thresholds config object dependant of the specified value
    // values may string values like '65,34%' or Numbers like 43.12
    // if specified value or the config is not valid this method will return the specified default color
    getThresholdColor(thresholdConfig, value, defaultColor, sourceItem) {
      let retVal = defaultColor;

      if (thresholdConfig && value != undefined && value != null) {
        // normalize value
        const valueNormalized = isNaN(value) && (value.length > 0) ? Number(value.replace('%', '').replace(',','.')) : value;

        // find corresponding threshold
        const threshold = thresholdConfig.find(thr => (thr.Minimum <= valueNormalized) && (valueNormalized <= thr.Maximum));
        if (threshold) {
          retVal = threshold.Color;
        }
      }

      return retVal;
    },

    getThresholdText(items, th, unit = '', separator = '-') {
      if (th == _.last(items)) {
        if (Math.floor(th.Minimum) == Math.floor(th.Maximum)) {
          return `${Math.floor(th.Maximum)}${unit}`;
        } else {
          return `${Math.floor(th.Minimum)}${unit}${separator}${Math.floor(th.Maximum)}${unit}`;
        }
      } else {
        return `${Math.floor(th.Minimum)}${unit}${separator}${Math.floor(th.Maximum)}${unit}`;
      }
    },

    getThreshold(thresholdConfig, value) {
      if (thresholdConfig && value != undefined && value != null) {
        // normalize value
        const valueNormalized = isNaN(value) && (value.length > 0) ? Number(value.replace('%', '').replace(',','.')) : value;

        // find corresponding threshold
        const threshold = thresholdConfig.find(thr => (thr.Minimum <= valueNormalized) && (valueNormalized <= thr.Maximum));
        if (threshold) {
          return threshold;
        }
      }

      return null;
    }
  }
};